<template>

  <div id="inviteCreate">
    <div class="dialog-content">
      
      <div class="context" v-if="action === 'selected-unit'">
        To invite a user to this unit, enter their email address and select a role. You can also <span class="vo-link" @click="addExistingUser">add an existing user</span> to this unit.</div>
      <div class="context" v-else>To invite a user, enter an email address, select a role template, and select any extra information required for their role.</div>
    
      <!-- EMAIL -->
      <v-text-field
        ref="inputEmail"
        label="Email"
        type="email"
        prepend-icon="mdi-account-plus"
        v-model="invite.email"
        :rules="rules.email" 
        :validate-on-blur="$refs.inputEmail && $refs.inputEmail.valid" 
      ></v-text-field>
          
      <!-- ROLE -->
      <v-select
        ref="selectRole"
        label="Role"
        prepend-icon="mdi-clipboard-account"
        item-text="title"
        item-value="_id"
        :items="roleTemplates"
        :rules="rules.role"
        v-model="invite.role"
      ></v-select>

      <!-- PROPERTY -->
      <v-select
        v-if="showProperty"
        ref="selectProperty"
        label="Property"
        prepend-icon="mdi-domain"
        item-text="name"
        item-value="_id"
        :items="properties"
        :rules="rules.property"
        v-model="invite.property"
        :disabled="action === 'selected-unit'"
      ></v-select>

      <!-- UNIT -->
      <v-select
        v-if="showUnit"
        ref="selectUnit"
        label="Unit"
        prepend-icon="mdi-home"
        item-text="title"
        item-value="_id"
        :rules="rules.unit"
        v-model="invite.unit"
        :items="units"
        :disabled="!invite.property || action === 'selected-unit'"
        :search-input.sync="unitSearch"
        :loading="invite.property && unitsLoading"
        autocomplete
      ></v-select>

    </div>
    <div class="dialog-footer">
      <v-btn class="button" :disabled="lockout.on" flat color="info" @click="routeRemoveQuery('dialog')">Cancel</v-btn>
      <v-btn class="button" :loading="lockout.on" flat color="primary" @click="create">Create</v-btn>
    </div>
  </div>
</template>

<script>

  import _ from 'lodash'
  import permissionMixin from '../mixins/permissionMixin.js'

  export default {
    mixins: [permissionMixin],
    data () {
      return {
        title: 'Create Invite',
        action: '',
        invite: {
          email: '',
          role: null,
          property: null,
          unit: null
        },
        units: [],
        unitsLoading: true,
        unitSearch: '',
        rules: {
          email: [
            function (e) {
              return !window.regex.email.test(e) ? 'Please enter a valid email address.' : true
            }
          ],
          role: [
            function (e) {
              return !e ? 'Please select a role.' : true;
            }
          ],
          property: [
            function (e) {
              return !e ? 'Please select a property.' : true;
            }
          ],
          unit: [
            function (e) {
              return !e ? 'Please select a unit.' : true;
            }
          ]
        }
      }
    },
    props: {
      lockout: {

      },
      dialogComponent: {

      }
    },

    computed: {

      properties () {
        return this.getAccessiblePropertiesList(['invite']);
      },
      
      roleTemplates () {
        // Check which roles they have access to inviting

        if (this.hasPermissions(['role']) && this.action !== 'selected-unit') {
          return _.values(this.$store.getters.roleTemplates)
        }
        else {
          // Just get Unit based roles
          var roles = [];
          
          for (var key in this.$store.getters.roleTemplates) {
            if (this.$store.getters.roleTemplates[key].requires && this.$store.getters.roleTemplates[key].requires.unit) {
              roles.push(this.$store.getters.roleTemplates[key]);
            }
          };

          return roles;
        }
      },

      showProperty () {
        return this.action === 'selected-unit' || (this.invite.role && this.$store.getters.roleTemplate(this.invite.role).requires && this.$store.getters.roleTemplate(this.invite.role).requires.property)
      },

      showUnit () {
        return this.action === 'selected-unit' || (this.invite.role && this.$store.getters.roleTemplate(this.invite.role).requires && this.$store.getters.roleTemplate(this.invite.role).requires.unit)
      }

    },

    methods: {
      
      addExistingUser () {
        this.routeRemoveQueries(['dialog', 'dialogAction']);

        setTimeout(() => {
          this.routeAddQueries({dialog: 'role-manage', dialogAction: 'selected-unit'});
        }, 300);
      },

      create () {
        if (this.lockout.on) return;
        this.lockout.on = true;
        
        var valid = this.validate();

        if (!valid) {
          Toast.show('Please correct the highlighted errors.', 'error');
          this.lockout.on = false;
          return;
        }

        var invite = {
          email: this.invite.email,
          role: {
            parent: this.invite.role
          } 
        };

        // Check requires
        var role = this.$store.getters.roleTemplate(this.invite.role);
        if (role.requires && role.requires.property)  invite.role.property  = this.invite.property;
        if (role.requires && role.requires.unit)      invite.role.unit      = this.invite.unit;

        this.$store.dispatch('createInvite', {
          company: this.$store.getters.company._id,
          invite: invite
        })
        .then(data => {

          // Invites may not be loaded yet, check before adding to the list
          if (AppData.app.pages.invited.list.loaded) {

            // IMPROVE: This just unshifts regardless of the sort. We don't care too much to be precise right now, but this could be improved.
            AppData.app.pages.invited.list.addItem(data._id, {unshift: true}); 
          }

          // If were on the invites route, go to the new invite
          if (this.$route.name === 'invited') this.routeAddQuery('details', data._id);
          this.routeRemoveQuery('dialog');

          Toast.show('Invite sent.', 'success');
          this.lockout.on = false;
        })
        .catch(e => {
          console.log(e);
          this.lockout.on = false;
          Toast.showError(e);
        })

      },

      validate () {
        this.$refs.inputEmail.validate(true);
        this.$refs.selectRole.validate(true);

        var valid = (this.$refs.inputEmail.valid && this.$refs.selectRole.valid);

        if (this.invite.role && this.$store.getters.roleTemplate(this.invite.role).requires) {

          if (this.$store.getters.roleTemplate(this.invite.role).requires.property) {
            this.$refs.selectProperty.validate(true);
            if (!this.$refs.selectProperty.valid) valid = false;
          }
          if (this.$store.getters.roleTemplate(this.invite.role).requires.unit) {
            this.$refs.selectUnit.validate(true);
            if (!this.$refs.selectUnit.valid) valid = false;
          }
        }

        return valid;
      }

    },

    watch: {

      'invite.property' () {

        if (this.action === 'selected-unit') {
          this.unitsLoading = false;
          return; 
        }

        if (!this.invite.property) return;
        if (!this.$store.getters.roleTemplate(this.invite.role).requires.unit) return;

        this.units = [];
        this.unitsLoading = true;
        if (this.invite.unit) this.invite.unit = null;

        this.$store.dispatch('loadUnits', {
          company: this.$store.getters.company._id,
          filters: {
            property: this.invite.property
          }
        })
        .then(data => {
          this.unitsLoading = false;
          this.units = data;
        })
        .catch(e => {
          this.unitsLoading = false;
          console.log(e);
          Toast.showError(e);
        });
      },

      unitSearch: _.debounce(function () {
        if (this.action === 'selected-unit') {
          this.unitsLoading = false;
          return; 
        }
        if (!this.invite.property) return;
        this.unitsLoading = true;
        
        this.$store.dispatch('loadUnits', {
          company: this.$store.getters.company._id,
          filters: {
            property: this.invite.property,
            search: this.unitSearch
          }
        })
        .then(data => {
          this.units = data;
          this.unitsLoading = false;
        })
        .catch(e => {
          console.log(e);
          Toast.showError(e);
          this.unitsLoading = false;
        })

      }, 200),

      roleTemplates () {
        if (this.roleTemplates.length === 1) {
          this.invite.role = this.roleTemplates[0]._id;
        }
      }

    },

    created () {
      this.$emit('title', this.title);
      if (this.$route.query.dialogAction) {
        this.action = this.$route.query.dialogAction;
      }

      if (this.action === 'selected-unit') {
        this.invite.unit      = this.$store.getters.unit(this.app.pages.units.selected)._id;
        this.invite.property  = this.$store.getters.property(this.$store.getters.unit(this.app.pages.units.selected).property)._id;
        this.units = [this.$store.getters.unit(this.app.pages.units.selected)]; 
      }
    }
  }

</script>

<style lang="scss">

  @import '../css/global.scss';

  #inviteCreate {
    position: relative;

    .vo-link {
      @include fontPrimary500;
    }

    .dialog-content {
      padding: 16px;
      min-height: 400px;
    }

    @media screen and (max-width: 700px) {
    
      .dialog-content {
        min-height: 0;      
      }
    
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/InviteCreate.vue